// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthForm_auth__2vPO2","control":"AuthForm_control__2bwit","actions":"AuthForm_actions__21UQC","toggle":"AuthForm_toggle__JFQXD"};